import { Link } from 'react-router-dom';

import { DataTable, type Column } from '../components/DataTable.tsx';
import { Pagination } from '../components/Pagination.tsx';
import { dateOnly, statusClass, statusLabel } from '../lib/format.ts';
import { usePaginatedList } from '../lib/usePaginatedList.ts';

interface Row {
  id: number;
  doNo: string;
  doDate: string;
  sourceSoNo: string | null;
  customerNo: string | null;
  customerName: string | null;
  salesman: string | null;
  status: string;
}

export function DeliveryOrdersListPage() {
  const list = usePaginatedList<Row>({
    endpoint: '/api/dashboard/delivery-orders',
    defaultSortColumn: 'do_date',
    defaultSortDirection: 'DESC',
  });
  const columns: Column<Row>[] = [
    { key: 'do_no', label: 'DO no', sortable: true, className: 'mono', render: (r) => <Link to={`/delivery-orders/${encodeURIComponent(r.doNo)}`}>{r.doNo}</Link> },
    { key: 'do_date', label: 'Date', sortable: true, className: 'mono', render: (r) => dateOnly(r.doDate) },
    { key: 'source_so', label: 'Source SO', className: 'mono', render: (r) => r.sourceSoNo ? <Link to={`/sales-orders/${encodeURIComponent(r.sourceSoNo)}`}>{r.sourceSoNo}</Link> : '—' },
    { key: 'customer_no', label: 'Customer', sortable: true, render: (r) => r.customerNo ? <Link to={`/customers/${encodeURIComponent(r.customerNo)}`}>{r.customerName ?? r.customerNo}</Link> : '—' },
    { key: 'salesman', label: 'Salesman', render: (r) => r.salesman ?? '—' },
    { key: 'status', label: 'Status', sortable: true, render: (r) => <span className={`badge ${statusClass(r.status)}`}>{statusLabel(r.status)}</span> },
  ];
  return (
    <>
      <header className="main-header">
        <h1 className="main-title">Delivery orders</h1>
        <span className="main-subtitle">{list.data ? `${list.data.total} total` : ''}</span>
      </header>
      <div className="toolbar">
        <input placeholder="Search DO no or source SO…" defaultValue={list.state.search} onChange={(e) => list.setSearch(e.target.value)} />
      </div>
      {list.error && <div className="error">{(list.error as Error).message}</div>}
      {list.isLoading && !list.data && <div className="loading">Loading…</div>}
      {list.data && (
        <>
          <DataTable columns={columns} rows={list.data.rows} rowKey={(r) => r.id} sortColumn={list.state.sortColumn} sortDirection={list.state.sortDirection} onSortChange={list.toggleSort} />
          <Pagination page={list.state.page} pageSize={list.state.pageSize} total={list.data.total} onPageChange={list.setPage} />
        </>
      )}
    </>
  );
}
